import styled from "styled-components";
import { createTriangleStyles } from "../../utils/create-triangle-styles.es.js";
const TooltipBox = styled("div")(
  ({ theme }) => ({
    backgroundColor: "rgba(0, 0, 0, 0.85)",
    borderRadius: 4,
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
    color: "rgba(255, 255, 255, 0.85)",
    display: "table",
    fontFamily: theme.fontFamily.default,
    fontSize: theme.fontSize.default,
    lineHeight: theme.lineHeight.default,
    padding: "4px 8px",
    position: "relative",
    transformOrigin: "inherit",
    whiteSpace: "pre-line"
  }),
  ({ $maxWidth }) => ({
    maxWidth: $maxWidth
  }),
  ({ $placement }) => ({
    top: { marginBottom: 5 },
    bottom: { marginTop: 5 },
    left: { marginRight: 5 },
    right: { marginLeft: 5 }
  })[$placement],
  ({ $justify, $placement, $showTriangle, $targetSize }) => $showTriangle && {
    "&::before": createTriangleStyles({
      color: "rgba(0, 0, 0, 0.85)",
      justify: $justify,
      offset: $justify !== "center" && $targetSize ? $targetSize / 2 : void 0,
      placement: $placement,
      size: 5
    })
  }
);
const TooltipSupplementary = styled("div")({
  color: "rgba(255, 255, 255, 0.65)",
  whiteSpace: "pre-wrap"
});
export {
  TooltipBox,
  TooltipSupplementary
};
